import variables from "lib/i18nHelperVariables";

export const enhancedT = originalT => (key, options = {}) => {
  const dynamicOptions = { ...variables, ...options };
  return originalT(key, dynamicOptions);
};
